import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/app/src/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/src/layouts/default.vue").then(m => m.default || m))
}